module.exports = __webpack_public_path__ + "static/media/swap.d5ebd757.svg";